export const PREVIOUS_LOCATION = 'previous-location';
export const IGNORE_PREVIOUS_LOCATION = 'ignore-previous-location';
